
import OnboardHeader from '../OnboardHeader.vue'
import PreEntryApi from '../../assets/js/preentry'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Loading from 'vux/src/components/loading/index.vue'

export default {
components: {
Flexbox,
XButton,
FlexboxItem,
Loading,
OnboardHeader,
Confirm
},

data () {
return {
isPrivacyAuth: false,
showTips: false,
trigger_position: 1,
page_type: 2
}
},
created () {
this.id = this.$route.query.id
this.trigger_position = this.$route.query.trigger_position
this.isPrivacyAuth = this.$route.query.is_agree
if (this.trigger_position === 2) {
this.showTips = true
}
},
mounted () {

},
methods: {
goPreView () {
if (!this.isPrivacyAuth) {
this.showTips = true
this.trigger_position = 2
return true
} else {
this.trigger_position = 1
PreEntryApi.savePrivacy(

{ id: this.id, code: this.code, trigger_position: this.trigger_position, page_type: this.page_type, proto_content: ''},
() => {
this.$router.push({ name: 'onboard.material', query: { id: this.id } })
},
err => {
this.showLoading = false
if (err === -2) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
}
)
}
},
onprivacyCancel () {
this.trigger_position = 1
},
onprivacyConfirm () {
this.isPrivacyAuth = true
this.trigger_position = 2
PreEntryApi.savePrivacy(

{ id: this.id, code: this.code, trigger_position: this.trigger_position, page_type: this.page_type, proto_content: ''},
() => {
this.$router.push({ name: 'onboard.material', query: { id: this.id } })
},
err => {
this.showLoading = false
if (err === -2) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
}
)
},
showPrivacyInfo () {
this.$router.push({ name: 'onboard.privacy_info', query: { id: this.id, trigger_position: this.trigger_position, is_agree: this.isPrivacyAuth, page_type: this.page_type } })
}
}
}



// WEBPACK FOOTER //
// ./src/components/onboard/privacy_tips.vue